export class WebhookV1AnomalyDataPoint {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "WebhookV1ProtobufTimestamp",
            "format": ""
        },
        {
            "name": "actualValue",
            "baseName": "actual_value",
            "type": "number",
            "format": "double"
        },
        {
            "name": "forecastValue",
            "baseName": "forecast_value",
            "type": "number",
            "format": "double"
        },
        {
            "name": "upperBound",
            "baseName": "upper_bound",
            "type": "number",
            "format": "double"
        },
        {
            "name": "lowerBound",
            "baseName": "lower_bound",
            "type": "number",
            "format": "double"
        },
        {
            "name": "isAnomaly",
            "baseName": "is_anomaly",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "snapshotId",
            "baseName": "snapshot_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "pointInTime",
            "baseName": "point_in_time",
            "type": "WebhookV1ProtobufTimestamp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1AnomalyDataPoint.attributeTypeMap;
    }
    constructor() {
    }
}
